module.exports = __webpack_public_path__ + "static/media/edit.463e8b1d.svg";